<template>
  <span class="svg-ico-plus">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6943 22.1747C12.2801 22.1747 11.9443 21.8389 11.9443 21.4247L11.9443 5.4247C11.9443 5.01048 12.2801 4.6747 12.6943 4.6747C13.1086 4.6747 13.4443 5.01048 13.4443 5.4247L13.4443 21.4247C13.4443 21.8389 13.1086 22.1747 12.6943 22.1747Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75207 13.2324C3.75207 12.8182 4.08785 12.4824 4.50207 12.4824L20.5021 12.4824C20.9163 12.4824 21.2521 12.8182 21.2521 13.2324C21.2521 13.6466 20.9163 13.9824 20.5021 13.9824L4.50207 13.9824C4.08785 13.9824 3.75207 13.6466 3.75207 13.2324Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
